'use client';

import { useAppSelector } from '@repo/store/maps/hooks';
import { selectMapData } from '@repo/store/maps/slices/mapData';
import type { VerticalLevel } from '@repo/types/maps/map-marker';
import type { MapIconFonts } from '@repo/types/maps/map-types';
import type * as MapLibre from 'maplibre-gl';
import { useCallback, useRef } from 'react';
import { getCachedMarkerImageData, loadMarkerImageData } from '../utils/marker-image';
export function useMarkerImageFactory() {
  const mapData = useAppSelector(selectMapData);
  const mapDataRef = useRef(mapData);
  mapDataRef.current = mapData;
  const addMarkerImageToMap = useCallback((id: string, color: string, subcategoryExternalId: string, found: boolean, selected: boolean, supportedFonts: MapIconFonts, map: MapLibre.Map, verticalLevel: VerticalLevel = null, highlighted: boolean = false) => {
    const request = {
      id,
      color,
      subcategoryExternalId,
      found,
      selected,
      supportedFonts,
      mapData: mapDataRef.current,
      verticalLevel,
      highlighted
    };
    const cachedImage = getCachedMarkerImageData(request);
    if (cachedImage) {
      if (map.hasImage(id)) {
        map.removeImage(id);
      }
      map.addImage(id, cachedImage.image, {
        pixelRatio: cachedImage.pixelRatio
      });
      return cachedImage.image;
    }
    if (!map.hasImage(id)) {
      map.addImage(id, {
        width: 1,
        height: 1,
        data: new Uint8Array(4)
      });
    }
    void loadMarkerImageData(request).then(markerImage => {
      if (map.hasImage(id)) {
        map.removeImage(id);
      }
      map.addImage(id, markerImage.image, {
        pixelRatio: markerImage.pixelRatio
      });
    }).catch(() => undefined);
  }, []);
  return {
    addMarkerImageToMap
  };
}